/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnaircoolingactualsetpoint4Inputs */



/**
* | output |
* | --- |
* | "Return air actual cooling setpoint" |
*
* @param {Ahu_History_Key_Returnaircoolingactualsetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnaircoolingactualsetpoint4 = /** @type {((inputs?: Ahu_History_Key_Returnaircoolingactualsetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnaircoolingactualsetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air actual cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle froid air reprise")
});
export { ahu_history_key_returnaircoolingactualsetpoint4 as "ahu_history_key_returnAirCoolingActualSetpoint" }